import React from "react";
import { Form } from "react-bootstrap";
import { useArsListing } from "./ArsListingContextProvider";
import { ARSL_SET_CURRENT_DATASET } from "./interface";

/**
 * DatasetSelect provides a dropdown to select between available clinical datasets.
 *
 * @returns Dataset selection dropdown
 */
export const DatasetSelect = (): React.ReactNode => {
  const { state, dispatch } = useArsListing();

  return !state ? null : (
    <Form.Select
      size="sm"
      value={state.settings.currentDatasetId}
      disabled={state.settings.disabled || state.settings.datasets.length === 0}
      onChange={(event) => {
        dispatch({ operation: ARSL_SET_CURRENT_DATASET, datasetId: event.currentTarget.value });
      }}
    >
      {!state.settings.datasets.map((d) => d.id).includes(state.settings.currentDatasetId) && (
        <option>-- Select --</option>
      )}
      {state.settings.datasets.map((dataset) => (
        <option
          key={dataset.id}
          value={dataset.id}
        >
          {dataset.name}
        </option>
      ))}
    </Form.Select>
  );
};

DatasetSelect.displayName = "DatasetSelect";
